import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";

export function UpdatePasswordPage() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [checking, setChecking] = useState(true);
  const [hasSession, setHasSession] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [showPasswords, setShowPasswords] = useState(false);

  useEffect(() => {
    let active = true;

    supabase.auth.getSession().then(({ data }) => {
      if (!active) return;
      setHasSession(Boolean(data.session));
      setChecking(false);
    });

    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!active) return;
      setHasSession(Boolean(session));
      setChecking(false);
    });

    return () => {
      active = false;
      listener.subscription.unsubscribe();
    };
  }, []);

  async function updatePassword(event) {
    event.preventDefault();
    setError("");

    if (password.length < 12) {
      return setError("Use at least 12 characters for your new password.");
    }
    if (password !== confirmation) {
      return setError("The password confirmation does not match.");
    }

    setSaving(true);
    const { error: updateError } = await supabase.auth.updateUser({ password });
    if (updateError) {
      setSaving(false);
      return setError(updateError.message);
    }

    await supabase.auth.signOut();
    navigate("/login", { replace: true, state: { passwordUpdated: true } });
  }

  return (
    <div className="screen centered">
      <form className="card form" onSubmit={updatePassword}>
        <h1>Set Your Password</h1>
        <p>Create the password you will use for the Coach Homes III portal.</p>
        {error ? <div className="error-block" role="alert">{error}</div> : null}
        {checking ? <div className="info auth-message" role="status">Validating your secure link…</div> : null}
        {!checking && !hasSession ? (
          <div className="error-block" role="alert">
            This link has expired or is invalid. Request a new link from the sign-in page.
          </div>
        ) : null}
        <p id="password-requirements" className="auth-field-help">Use at least 12 characters. A memorable phrase is usually easier to enter and harder to guess.</p>
        <label>
          New password
          <input
            type={showPasswords ? "text" : "password"}
            autoComplete="new-password"
            minLength="12"
            aria-describedby="password-requirements"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            disabled={!hasSession || saving}
            required
          />
        </label>
        <label>
          Confirm new password
          <input
            type={showPasswords ? "text" : "password"}
            autoComplete="new-password"
            minLength="12"
            aria-describedby="password-requirements"
            value={confirmation}
            onChange={(event) => setConfirmation(event.target.value)}
            disabled={!hasSession || saving}
            required
          />
        </label>
        <label className="checkbox-row auth-show-password"><input type="checkbox" checked={showPasswords} onChange={(event) => setShowPasswords(event.target.checked)} disabled={!hasSession || saving} />Show passwords</label>
        <button type="submit" disabled={!hasSession || saving}>
          {saving ? "Saving…" : "Save Password"}
        </button>
        <Link className="auth-help-link" to="/forgot-password">Request another secure link</Link>
      </form>
    </div>
  );
}
